// assets/km-cart-drawer-refresh.js
(() => {
  const SEL = {
    drawer: "cart-drawer-component#km-cart-drawer, cart-drawer-component[data-km-cart-drawer]",
    dialog: "dialog",
  };

  const log = (...a) => console.log("%c[KM CART REFRESH]", "color:#0B894C;font-weight:700", ...a);
  const getDrawer = () => document.querySelector(SEL.drawer);

  function getSectionId(drawer) {
    return drawer?.dataset?.kmCartSectionId || drawer?.getAttribute?.("data-km-cart-section-id") || "";
  }

  async function fetchSectionHTML(sectionId) {
    const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`sections fetch failed: ${res.status}`);
    const json = await res.json();
    return json?.[sectionId] || "";
  }

  function replaceDialogHTML(currentDrawer, freshHTML) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(freshHTML, "text/html");
    const freshDrawer = doc.querySelector(SEL.drawer);
    if (!freshDrawer) throw new Error("fresh drawer not found in returned section html");

    const curDlg = currentDrawer.querySelector(SEL.dialog);
    const newDlg = freshDrawer.querySelector(SEL.dialog);
    if (!curDlg || !newDlg) throw new Error("dialog missing");

    const wasOpen = curDlg.hasAttribute("open");
    curDlg.innerHTML = newDlg.innerHTML;
    if (wasOpen) curDlg.setAttribute("open", "");

    document.dispatchEvent(new CustomEvent("km:cart-drawer:refreshed", {
      detail: { sectionId: getSectionId(currentDrawer) }
    }));

    // Atualiza o count do icone do carrinho no header
    _updateCartCount();
  }

  async function _updateCartCount() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } });
      const cart = await res.json();
      const count = cart.item_count || 0;
      // Seletores comuns do tema para o badge de contagem
      document.querySelectorAll([
        ".cart-count-bubble",
        "[data-cart-count]",
        ".cart-bubble",
        ".km-cart-bubble",
        ".cart-bubble__count",
        "[data-cart-bubble]",
        ".header__icon--cart .badge",
        ".cart-icon-bubble",
      ].join(",")).forEach((el) => {
        // Atualiza texto se o elemento contiver so numero
        if (el.children.length === 0) {
          el.textContent = count > 0 ? String(count) : "";
        } else {
          // Caso o tema use um span interno para o numero
          const inner = el.querySelector("span, [data-count]") || el;
          inner.textContent = count > 0 ? String(count) : "";
        }
        // Esconde/mostra o badge
        el.style.display = count > 0 ? "" : "none";
      });
    } catch {}
  }

  let inflight = null;
  let scheduled = false;

  async function refreshDrawer(reason = "unknown") {
    const drawer = getDrawer();
    if (!drawer) return;

    const sectionId = getSectionId(drawer);
    if (!sectionId) { log("No sectionId on drawer; skipping refresh"); return; }
    if (inflight) return inflight;

    inflight = (async () => {
      try {
        log("refresh start:", reason, "section:", sectionId);
        const html = await fetchSectionHTML(sectionId);
        replaceDialogHTML(drawer, html);
        log("refresh OK:", reason);
      } catch (e) {
        console.warn("[KM CART REFRESH] refresh failed:", e);
      } finally {
        inflight = null;
      }
    })();

    return inflight;
  }

  function queueRefresh(reason, delay = 60) {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      refreshDrawer(reason);
    }, delay);
  }

  // ── Triggers ──────────────────────────────────────────────────────────────

  // 1) Eventos do tema / custom events
  ["CartAddEvent", "cart:refresh", "cart:updated", "cart:update", "cart:change", "cart:add"].forEach((ev) => {
    document.addEventListener(ev, () => queueRefresh(ev), true);
  });

  // 2) Intercepta fetch nativo para /cart/* — inclui quick-buy
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const url = typeof args[0] === "string" ? args[0] : (args[0]?.url || "");
      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear")
      ) {
        // Delay maior para quick-buy (o tema pode precisar de mais tempo pra processar)
        queueRefresh("fetch:" + url.split("?")[0], 600);
      }
    } catch {}
    return res;
  };

  // 3) Drawer aberto stale
  document.addEventListener("km:cart-drawer:opened", () => queueRefresh("opened"), true);

  // 4) Evento km:cart-updated disparado pelo upsell
  document.addEventListener("km:cart-updated", () => queueRefresh("km:cart-updated"), true);

  log("installed");
})();